<template>
  <div>
    <div class="tab-bar mb-2">
      <div
        v-for="(tab, index) in tabs"
        :key="index"
        @click="selectTab(index)"
        class="text-decoration-none align-items-center mr-5 tab-item"
        :class="index === isSelected ? 'tab-item-active' : ''"
        style="cursor: pointer;"
      >
        {{ tab }}
      </div>
    </div>
    <slot>tabArea</slot>
  </div>
</template>

<script>
export default {
  props: {
    tabs: Array,
  },
  mounted() {
    this.selected = this.tabs[0] ?? null
  },
  computed: {
    isSelected: function() {
      if (this.selected) {
        return this.tabs.indexOf(this.selected)
      } else {
        return 0
      }
    },
  },
  data() {
    return {
      selected: null,
    }
  },
  methods: {
    selectTab(index) {
      this.selected = this.tabs[index]
    },
  },
}
</script>

<style lang="scss">
.tab-bar {
  border-bottom: 1px solid $gray-500;
}
.tab-item {
  display: inline-block;
  margin-bottom: -1px;
  padding-bottom: 8px;
  opacity: 0.8;
  color: $gray-600 !important;
  border-bottom: 1px solid $gray-500;
  font-size: 17px !important;
  font-weight: 600;
  &:hover {
    border-bottom: 1px solid $gray-600;
    opacity: 1;
  }
}

.tab-item-active {
  color: $gray-base !important;
  border-bottom: 1px solid $gray-base !important;
  opacity: 1;
}
</style>
